<template>
  <div>
    <b-container class="d-flex align-items-center justify-content-center" style="height: 100vh;">
      <div class="auth-wrapper auth-v2">
        <b-row class="auth-inner m-0">
          <b-col md="8" class="offset-lg-2 d-flex flex-column p-5 bg-white">
            <b-row class="mb-4 d-md-flex text-center ">
              <b-col md="4" class="float-left">
                <a href="https://www.subu.edu.tr/tr" target="_blank" rel="noopener noreferrer">
                  <b-img src="@/assets/images/logo/subuLogo.png" class="logo" />
                </a>
              </b-col>
              <b-col md="4">
                <div>
                  <b-button @click="navigateToLink" class="kesfet" variant="success">SUBÜ'YÜ KEŞFET</b-button>
                </div>
              </b-col>
              <b-col md="4" class="">
                <b-img src="@/assets/images/logo/motto.png" class="motto float-right" />
              </b-col>
            </b-row>
            <h2 class="text-center mb-4" style="color: #333; margin-top: 75px; font-size: 2.6rem;"><strong>KALİTE YÖNETİM
                SİSTEMİ</strong></h2>
            <b-row class="p-2 text-center">
              <b-col md="3" class="mb-3 mx-auto d-flex flex-column align-items-center">
                <a href="https://kp.subu.edu.tr" target="_blank" rel="noopener noreferrer">
                  <b-img src="@/assets/images/icons/kurumsal_performans_ikon.jpg" class="button-image" />
                  <b-card-text style="font-size: 1.5rem; font-weight: bold; color: #333; padding: 8px;">KURUMSAL
                    PERFORMANS</b-card-text>
                </a>
              </b-col>
              <b-col md="3" class="mb-3 mx-auto d-flex flex-column align-items-center">
                <a href="https://kz.subu.edu.tr/" target="_blank" rel="noopener noreferrer">
                  <b-img src="@/assets/images/icons/kurumsal_zeka_ikon.jpg" class="button-image" />
                  <b-card-text style="font-size: 1.5rem; font-weight: bold; color: #333; padding: 8px;">KURUMSAL
                    ZEKA</b-card-text>
                </a>
              </b-col>
              <b-col md="3" class="mb-3 mx-auto d-flex flex-column align-items-center">
                <a href="https://qdms.subu.edu.tr" target="_blank">
                  <b-img src="@/assets/images/icons/QDMS_ikon.jpg" class="button-image" />
                  <b-card-text style="font-size: 1.5rem; font-weight: bold; color: #333; padding: 8px;">QDMS</b-card-text>
                </a>
              </b-col>
              <b-col md="3" sm="4" class="mb-3 mx-auto d-flex flex-column align-items-center">
                <a href="https://anket.subu.edu.tr/" target="_blank" rel="noopener noreferrer">
                  <b-img src="@/assets/images/icons/anket_ikon.jpg" class="button-image" />
                  <b-card-text style="font-size: 1.5rem; font-weight: bold; color: #333; padding: 8px;">ANKET
                    YÖNETİMİ</b-card-text>
                </a>
              </b-col>
            </b-row>
            <b-row class="mb-2 text-center">
              <b-col md="3" class="mb-3 mx-auto d-flex flex-column align-items-center">
                <a href="https://bidr.subu.edu.tr" target="_blank">
                  <b-img src="@/assets/images/icons/BIDR_ikon.jpg" class="button-image" />
                  <b-card-text style="font-size: 1.5rem; font-weight: bold; color: #333; padding: 8px;">BİRİM İÇ
                    DEĞERLENDİRME RAPORU</b-card-text>
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <footer class="footer mt-auto py-2">
      <div class="container text-center">
        <p>
          Telif Hakkı &copy; 2024
          <a href="https://www.subu.edu.tr/tr" target="_blank" rel="noopener noreferrer">Sakarya Uygulamalı Bilimler
            Üniversitesi</a>
        </p>
      </div>
    </footer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  methods: {
    navigateToLink() {
      window.location.href = 'https://kesfet.subu.edu.tr/', '_blank';
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.logo {
  width: 250px;
}

.kesfet {
  border-radius: 30px;
  color: rgb(4, 110, 4);
  margin-top: 20px;
}

.motto {
  width: 200px;
  margin-top: 8px;
}

.button-image {
  width: 220px;
  padding: 10px;
}

.custom-button {
  margin-top: 8px;
  width: 100%;
}

.footer {
  background-color: #f8f9fa;
  color: #333;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.footer a {
  color: #007bff;
  text-decoration: underline;
}
</style>